import React from "react";
import {IBookingSearchResultRecord} from "../../../airline-webapi/responses/booking-search.response";
import {BookingSearchStrategyType} from "../booking-search.strategy.interface";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {SearchByEmailComponent} from "./search-by-email.component";
import {
    IBookingSearchByEmailRequest,
    IBookingSearchPagination
} from "../../../airline-webapi/requests/booking-search.requests";
import {IBookingSearchCommonPersistedFields, IBookingSearchCommonFields} from "../common/booking-search-common-fields.interface";
import {StandardBookingSearchStrategy} from "../common/standard-booking-search.strategy";
import {NullableString} from "../../../../types/nullable-types";
import {mailOutline} from "ionicons/icons";

interface ISearchByEmailFields extends IBookingSearchCommonFields {
    email: string;
}

interface ISearchByEmailPersistedFields extends IBookingSearchCommonPersistedFields {
    email: string;
}

export class SearchByEmailStrategy extends StandardBookingSearchStrategy<ISearchByEmailFields, ISearchByEmailPersistedFields> {

    get type(): BookingSearchStrategyType {
        return BookingSearchStrategyType.ByEmail;
    }

    get name(): string {
        return  this.services.language.translate("By email");
    }

    get resultsDescription(): string {
        return this.services.language.translate("Results by email");
    }

    protected _getIonIconName(): NullableString {
        return mailOutline;
    }

    protected _createFilterFields(persistedFields: ISearchByEmailPersistedFields): FormFields<ISearchByEmailFields> {
        return {
            email: this._createEmailField({
                isRequired: true,
                defaultValue: persistedFields?.email ?? null,
            }),
            ...this._createCommonFields(persistedFields)
        }
    }

    renderSearchFields(): React.ReactElement {
        return (
            <SearchByEmailComponent strategy={this}/>
        );
    }

    async _searchBookings(sessionToken: string, pagination: IBookingSearchPagination): Promise<IBookingSearchResultRecord[]> {
        const request: IBookingSearchByEmailRequest = {
            dotRezToken: sessionToken,
            email: this.fields.email.value!,
            filters: this._createCommonFilters(pagination),
        }

        const response = await this.services.airlineWebapi.agencyBookingSearchByEmail(request);
        return response.results;
    }


    protected _collectFieldsValuesForStorage(): ISearchByEmailPersistedFields {
        return {
            email: this.fields.email.value ?? "",
           ...this._collectCommonFieldsValuesForStorage()
        };
    }

}